class Navigation {
    constructor(options = {}){
        this.options = Object.assign( 
            {},
            {   
                ruptureBurger : 1220
            }, 
            options
        );   
 
        this.categories_mob = this.options.categories_mob; 
        this.pastilles_mob = this.options.pastilles_mob; 

        this.burger = document.querySelector(".mobile-nav-trigger"); 
        this.contentCategoriesFront = document.querySelector(".menu-left.mob .categories-mob");
        this.contentPastillesFront = document.querySelector(".menu-left.mob .pastilles-mob"); 
 

        this.burger.addEventListener("click", () => {
            this.burger.classList.toggle("is-active");
            document.querySelector("body").classList.toggle("freeze");
            document.querySelector("html").classList.toggle('freeze'); 
            document.querySelector(".content-menu").classList.toggle("open");
        }); 
      
        this.menuLink0 = document.querySelectorAll(".menu-left .link-level0.plus"); 
        this.menuLink0.forEach(m => {
            m.addEventListener("click", (e) => {
                e.preventDefault();
                if(document.querySelector("body").offsetWidth < this.options.ruptureBurger || this.hasTouchScreen){ 
                    m.closest(".cat").classList.toggle("open"); 
                }else{
                    window.location.href = m.getAttribute("href");
                }
            });
        }); 
    
        this.menuLink1 = document.querySelectorAll(".menu-left .level1 .plus"); 
        this.menuLink1.forEach(m => {
            m.addEventListener("click", (e) => { 
                if(document.querySelector("body").offsetWidth < this.options.ruptureBurger){ 
                    e.preventDefault();
                    m.closest(".level1").classList.toggle("open"); 
                } 
            });
        });    

        document.addEventListener("cssLoaded", () => {
            document.querySelectorAll(".toload").forEach(l => {
            l.classList.add("loaded");
            });
        });   

        document.querySelectorAll('.vignettes').forEach(el => {
            el.addEventListener('wheel', (e) => {
                e.preventDefault();
                el.scrollLeft += e.deltaY;
            }, { passive: false });
        });
 

        this.buildCategories(this.categories_mob.categories);
        console.log("pastilles", this.pastilles_mob.pastilles);
        this.buildPastilles(this.pastilles_mob.pastilles);
         
    }

    buildCategories(categories){  
        let arImage = [];
        let contentCategories = this.createElementWithClass("div", "categories");
        categories.forEach(cat => {
            let contentCat = this.createElementWithClass("a", "categorie");
            contentCat.href = cat.url;
            let contentCatImg = this.createElementWithClass("div", "content-img");
            let imgCat = this.createElementWithClass("img", "img-cat");
            imgCat.classList.add("lazy");
            imgCat.classList.add("ext");
            imgCat.setAttribute("data-src", cat.img);
            imgCat.setAttribute("alt", contentCat);
            contentCatImg.appendChild(imgCat);
            let contentCatDesc = this.createElementWithClass("div", "content-desc");
            contentCatDesc.innerHTML = cat.title;
            contentCat.appendChild(contentCatImg);  
            contentCat.appendChild(contentCatDesc); 
            contentCategories.appendChild(contentCat);  
            arImage.push(imgCat); 
        }); 
        this.contentCategoriesFront.appendChild(contentCategories);  
        new LazyLoader(arImage);
    }

    buildPastilles(pastilles){  
        let arImage = [];
        let contentPastilles = this.createElementWithClass("div", "pastilles");
        pastilles.forEach(pas => {
            let contentPas = this.createElementWithClass("a", "pastille");
            contentPas.href = pas.url;
            let contentPasImg = this.createElementWithClass("div", "content-img");
            let imgCat = this.createElementWithClass("img", "img-cat");
            imgCat.classList.add("lazy");
            imgCat.classList.add("ext");
            imgCat.setAttribute("data-src", pas.img);
            imgCat.setAttribute("alt", contentPas);
            contentPasImg.appendChild(imgCat);
            let contentPasDesc = this.createElementWithClass("div", "content-desc");
            contentPasDesc.innerHTML = pas.title;
            contentPas.appendChild(contentPasImg);  
            contentPas.appendChild(contentPasDesc); 
            contentPastilles.appendChild(contentPas);  
            arImage.push(imgCat); 
        }); 
        this.contentPastillesFront .appendChild(contentPastilles);  
        new LazyLoader(arImage);
    } 

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }
 
}


